import i18n from "@/shared/config/i18n";
export const ConstructorStatus = Object.freeze({
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
  DEACTIVATION: "DEACTIVATION",
});

export const ConstructorStatusLabel = {
  [ConstructorStatus.DRAFT]: i18n.global.t("Черновик"),
  [ConstructorStatus.ACTIVE]: i18n.global.t("Активен"),
  [ConstructorStatus.ARCHIVED]: i18n.global.t("Архив"),
  [ConstructorStatus.DEACTIVATION]: i18n.global.t("Деактивация"),
};

export const ConstructorStatusColor = {
  [ConstructorStatus.DRAFT]:
    "flex items-center w-2 h-2 rounded-full bg-gray-300",
  [ConstructorStatus.ARCHIVED]:
    "flex items-center w-2 h-2 rounded-full bg-yellow-500",
  [ConstructorStatus.ACTIVE]:
    "flex items-center w-2 h-2 rounded-full bg-green-600",
  [ConstructorStatus.DEACTIVATION]:
    "flex items-center w-2 h-2 rounded-full bg-red-400",
};
